<template>
  <div class="form-con search whaty-search-input-text" data-stopPropagation="true">
    <div class="input-wrap" data-role="textSearch"
         @mouseenter="hovering = true"
         @mouseleave="hovering = false"
    >
      <input type="text" class="form-control el-input__inner"
             v-model="currentValue"
             :placeholder="placeholder"
             :style="inputStyle"
             @input="handleInput"
             @change="handleChange"
             @focus="onInputFocus"
             @blur="onInputBlur">
      <div v-if="nannSearch" @click="showSearchHistoryPanel = true"
           class="nann-tip-wrapper">
        <el-tag v-if="nannSearch === '!null'" size="mini">已填写</el-tag>
        <el-tag v-if="nannSearch === 'null'" size="mini">未填写</el-tag>
      </div>
      <div
        v-show="showInputFun"
        class="input-fun">
        <span class="shut" data-clear="true"><i class="mng icon-cross-fill"></i></span>
        <span class="arrow-wrap" data-condition="true"><span class="arrow"></span></span>
      </div>
      <span class="el-input__suffix">
        <span class="el-input__suffix-inner">
          <i v-if="showClear" @click="clear" class="el-input__icon el-icon-circle-close el-input__clear"></i>
          <i v-if="enableSearchMode"
            @click="toggleSearchModePanel"
            :class="{'is-reverse': showSearchModePanel}"
            class="el-select__caret el-input__icon el-icon-arrow-up"></i>
        </span>
      </span>
    </div>
    <!----------- dropdown search: text ---------->
    <div
      v-show="showSearchHistoryPanel"
      :style="searchHistoryStyle"
      class="history-panel drop drop-search" data-stopPropagation="true" data-textSearch="drop-history">
      <div class="drop-top">
        <ul class="clearfix" data-action="activeCurrent">
          <li
            @click="handleNANNSearchChange('!null')"
            class="drop-cell">
            <a
              :class="{active: nannSearch === '!null'}"
              href="javascript:;" class="drop-link" data-role="activeTarget" data-stopPropagation="true">
              <i class="mng icon-solidcircle drop-ico-pre"></i>
              <span class="drop-txt">已填写</span>
            </a>
          </li>
          <li
            @click="handleNANNSearchChange('null')"
            class="drop-cell">
            <a
              :class="{active: nannSearch === 'null'}"
              href="javascript:;" class="drop-link" data-role="activeTarget" data-stopPropagation="true">
              <i class="mng icon-hollowcircle drop-ico-pre"></i>
              <span class="drop-txt">未填写</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="drop-mid">
        <div class="clearfix drop-subtitle">
          <span class="pull-left drop-txt">历史搜索</span>
          <a @click="handleClearHistory" href="javascript:" class="btn btn-icon-only pull-right"><i class="mng icon-delete-stroke"></i></a>
        </div>
        <div v-loading="historyIsLoading" class="drop-cell-group">
          <ul class="clearfix">
            <template v-if="searchHistoryData.length > 0">
              <li v-for="item in searchHistoryData" class="drop-cell">
                <a @click="handleHistoryItemClick(item)" href="javascript:" class="drop-link"><span class="drop-txt">{{ item }}</span></a>
              </li>
            </template>
            <li v-else class="no-history-tip">没有历史搜索记录！</li>
          </ul>
        </div>
      </div>
    </div>
    <!----------- dropdown search:text end ---------->
    <!----------- dropdown search: condition ---------->
    <div
      v-show="showSearchModePanel"
      class="drop drop-base" data-stopPropagation="true" data-textSearch="drop-condition">
      <div class="drop-mid">
        <div class="clearfix drop-subtitle">
          <span class="pull-left drop-txt">搜索模式：</span>
        </div>
        <ul data-action="activeCurrent">
          <li v-for="item in searchModelArray" class="drop-list">
            <a @click="handleSearchModeChange(item.key)" href="javascript:"
               :class="{active: currentSearchMode === item.key}"
               class="drop-link" data-role="activeTarget" data-stopPropagation="true">
              <span class="drop-txt">{{ item.name }}</span>
              <i class="mng icon-tick-stroke drop-ico-tick drop-ico-suf"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!----------- dropdown search: condition end ---------->
  </div>
</template>
<script>
  import util from '../../libs/util'
  export default {
    name: 'whaty-search-input-text',
    props: {
      gridConfig: {
        type: Object,
        default() {
          return {}
        }
      },
      gridConfigUrl: {
        type: String,
        default: ''
      },
      value: [String, Number],
      placeholder: String,
      dataIndex: String
    },
    data() {
      return {
        focused: false,
        hovering: false,
        currentValue: '',
        searchHistoryWidth: 300, // 搜索历史面板的宽度
        searchHistoryData: [], // 搜索历史
        searchHistoryDataInitialized: false,
        historyIsLoading: false,
        showSearchHistoryPanel: false, // 是否显示搜索历史面板
        showSearchModePanel: false, // 是否显示搜索模式面板
        searchModelArray: [
          {name: '只要包含关键词', key: 'include'},
          {name: '等于关键词', key: 'exact'}
        ], // 支持的搜索模式
        currentSearchMode: 'include', // 搜索模式, exact: 精确模式, include: 包含模式
        nannSearch: '' // nann: null and not null, !null: 已填写, null: 未填写
      }
    },
    computed: {
      queryColumnHotSearchWord: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'queryColumnHotSearchWord')
      },
      clearColumnSearchHistory: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'clearColumnSearchHistory')
      },
      inputStyle() {
        return {
          'padding-right': this.showClear ? '46px' : '26px'
        }
      },
      searchHistoryStyle() {
        return {
          width: this.searchHistoryWidth + 'px'
        }
      },
      showInputFun() { // 是否显示右侧操作区, input内容不为空时显示
        return false
        // return (this.currentValue && this.currentValue.length > 0) || this.nannSearch
      },
      showClear() {
        return ((this.currentValue && this.currentValue.length > 0) || this.nannSearch) &&
          (this.focused || this.hovering)
      },
      enableSearchMode() {
        return (this.currentValue && this.currentValue.length > 0)
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {
      loadHotSearchWord() {
        this.historyIsLoading = true
        let params = {
          params: {
            actionId: this.gridConfig.gridId,
            gridUrl: this.gridConfigUrl,
            columnDataIndex: this.dataIndex
          }
        }
        util.ajax.post(this.queryColumnHotSearchWord, params).then((res) => {
          this.historyIsLoading = false
          this.searchHistoryDataInitialized = true
          if (res.data.meta.errCode === 0) {
            this.searchHistoryData = res.data.data
          }
        }).catch((err) => {
          this.historyIsLoading = false
          this.searchHistoryDataInitialized = true
          console.warn('获取搜索热词失败！')
          console.error(err)
        })
      },
      getValue() {
        let value = ''
        if (this.nannSearch) {
          value = this.nannSearch
        } else if (this.currentValue) {
          if (this.currentSearchMode === 'exact') {
            value = '= ' + this.currentValue
          } else {
            value = this.currentValue
          }
        }
        return value
      },
      emitInput() {
        let value = this.getValue()
        this.$emit('input', value)
      },
      emitChange() {
        let value = this.getValue()
        this.$emit('change', value)
      },
      onInputFocus() { // input获得焦点时
        // if (!this.searchHistoryDataInitialized) {
        //   this.loadHotSearchWord()
        // }
        this.loadHotSearchWord()
        this.focused = true
        this.showSearchHistoryPanel = true
      },
      onInputBlur() { // input失去焦点时
        this.focused = false
        // this.showSearchHistoryPanel = false
      },
      handleInput(event) { // input输入事件
        this.showSearchHistoryPanel = false
        this.currentValue = event.target.value
        this.emitInput()
      },
      handleChange(event) { // input值变化事件
        this.emitChange()
      },
      handleNANNSearchChange(mode) { // 选择NANN搜索事件
        this.currentValue = ''
        this.nannSearch = mode
        this.showSearchHistoryPanel = false
        this.emitInput()
      },
      clear() { // clear btn click event
        this.currentValue = ''
        this.nannSearch = ''
        this.emitInput()
      },
      toggleSearchModePanel() {
        this.showSearchModePanel = !this.showSearchModePanel
      },
      handleSearchModeChange(newVal) {
        this.currentSearchMode = newVal
        this.showSearchModePanel = false
        this.emitInput()
      },
      handleHistoryItemClick(text) {
        this.currentValue = text
        this.nannSearch = ''
        this.showSearchHistoryPanel = false
        this.emitInput()
      },
      handleClearHistory() {
        let params = {
          params: {
            actionId: this.gridConfig.gridId,
            gridUrl: this.gridConfigUrl,
            columnDataIndex: this.dataIndex
          }
        }
        util.ajax.post(this.clearColumnSearchHistory, params).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.searchHistoryData = []
            this.$notify.success({title: '成功', message: '清除成功'})
          }
        }).catch((err) => {
          this.$notify.success({title: '成功', message: '清除成功'})
          console.warn('清除列搜索记录失败！')
          console.error(err)
        })
      }
    },
    watch: {
      value: function value(val, oldValue) {
        if (val === 'null' || val === '!null') { // if val equal nannSearch
          this.nannSearch = val
        } else if (this.currentSearchMode === 'exact' && val.startsWith('= ')) {
          // do nothing
        } else if (val === undefined) {
          this.clear()
        } else {
          this.currentValue = val
        }
      }
    }
  }
</script>
<style src="./index.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/whaty-search-input-text/index.vue